<template>
    <a-modal
      :title="`${isCheck?'查看':nowObj?'编辑':'新增'}预警任务`"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      width="900px"
      :centered="true"
      class="add-warning-modal"
      :class="isCheck?'is-check':''"
    >
      <div class="top-info"><a-icon type="info-circle" theme="filled" />预警当前仅支持媒体数据的自有指标，第三方数据、混合数据及自定义指标暂不支持。</div>
      <a-form-model
        ref="form"
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="任务名称" prop="taskName" :rules="[
              { required: true, message: '请输入任务名称', trigger: 'blur' },
              { max: 50, message: '不能超过50个字符', trigger: 'blur' },
              { validator: validatorName, trigger: 'blur' },
            ]" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input  v-model="form.taskName" placeholder="请输入任务名称" :disabled="!!nowObj"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="任务类型" prop="taskType" :rules="[
              { required: true, message: '请选择任务类型', trigger: 'change' },
            ]" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
              <a-select v-model="form.taskType" @change="taskTypeChange" :disabled="isCheck" placeholder="请选择任务类型">
                <a-select-option value="1">消耗停止预警</a-select-option>
                <a-select-option value="2">自定义</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item label="订阅状态" prop="warningStatus" required>
          <a-select v-model="form.warningStatus" :disabled="isCheck">
            <a-select-option :value="1">启用</a-select-option>
            <a-select-option :value="0">禁用</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="监控数据范围" class="data-range" required>
          <a-form-model-item prop="mediaCode" class="no-style" 
            :rules="{ required: true, message: '请选择数据源', trigger: 'change',}"
          >
            <a-select :disabled="isCheck" v-model="form.mediaCode" placeholder="请选择数据源" @change="changeDataSource">
              <a-select-option v-for="item in dataSet" :key="item.mediaCode" :value="item.mediaCode">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="monitorDataAccount" class="no-style"
            :rules="{ required: true, message: '请选择', trigger: 'change',}"
          >
            <span v-if="isCheck">{{monitorDataAccountDetails}}</span>
            <a-select
              v-model="form.monitorDataAccount"
              mode="multiple"
              :filter-option="false"
              :maxTagCount="1"
              :maxTagTextLength="6"
              :placeholder="`请选择${form.monitorDataLevel}`"
              @search="handleSearchAccount"
              :disabled="isCheck"
              v-else
            >
              <a-select-option
                v-for="item in accountList"
                :key="item.accountId"
                :value="item.accountId"
              >
                {{ item.accountName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model-item>
        <a-form-model-item label="监控时间范围" prop="monitorDateScope"
          :rules="{ required: true, message: '不能为空', trigger: 'change',}"
        >
          <span v-if="isCheck">{{dateScopeMap[form.monitorDateScope] || ''}}</span>
          <a-radio-group v-model="form.monitorDateScope" @change="warningContentChange" v-else>
            <!-- <a-radio value="1">最近3天</a-radio>
            <a-radio value="2">最近7天</a-radio> -->
            <!-- <a-radio value="3">最近3小时</a-radio> -->
            <a-radio value="4">当日(0点开始)</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="监控指标" prop="intelligentMonitorTargetList" style="margin-bottom:0" required>
          <a-row v-for="(item, index) in form.intelligentMonitorTargetList" :key="index"
            style="line-height:44px" class="include-division-row"
          >
            <a-form-model-item class="no-style" prop="executeWarnTaskInterval"
              :rules="{ required: true, message: '请选择预警频次', trigger: 'change',}"
            >
              <span v-if="isCheck" style="margin-right: 20px">{{form.executeWarnTaskInterval}}</span>
              <a-select v-else :disabled="isCheck" v-model="form.executeWarnTaskInterval" placeholder="预警频次"
                 style="width: 104px"
              >
                <a-select-option v-for="value in taskIntervalList" :key="value"
                  :value="value"
                >{{value}}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item class="no-style" :prop="'intelligentMonitorTargetList.' + index + '.monitorTargetId'"
              :rules="{ required: true, message: '请选择指标', trigger: 'change',}"
            >
              <span v-if="isCheck" style="margin-right: 20px">{{item.monitorTargetName}}</span>
              <a-select v-else :disabled="isCheck" v-model="item.monitorTargetId" placeholder="预警指标" style="width: 140px"
                @search="searchNorm" show-search :filter-option="false" :dropdownMatchSelectWidth="false" @change="(val) => normChange(val, index)"
              >
                <a-select-option v-for="item in normList" :key="item.field"
                  :value="item.field"
                >{{item.name}}</a-select-option>
                <a-select-option v-for="item in shortNorm" :key="item.field"
                  :value="item.field"
                >{{item.name}}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item class="no-style" prop="monitorValueType"
              :rules="{ required: true, message: '请选择指标类型', trigger: 'change',}"
            >
              <span v-if="isCheck" style="margin-right: 20px">{{monitorValueTypeMap[form.monitorValueType]}}</span>
              <a-select v-else :disabled="isCheck" v-model="form.monitorValueType" placeholder="指标类型"
                 style="width: 104px"
              >
                <a-select-option v-for="(value, key) in monitorValueTypeMap" :key="key"
                  :value="key"
                >{{value}}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item class="no-style" :prop="'intelligentMonitorTargetList.' + index + '.monitorRule'"
              :rules="{ required: true, message: '请选择对比方式', trigger: 'change',}"
            >
              <a-select :disabled="isCheck" @change="warningContentChange" v-model="item.monitorRule" style="width: 104px" placeholder="对比方式">
                <a-select-option :value="key" v-for="(val, key) in monitorRuleSet" :key="key">{{val}}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item class="no-style" :prop="'intelligentMonitorTargetList.' + index + '.monitorNumber'"
              :rules="{ required: true, message: '请输入数值', trigger: 'blur',}"
            >
              <a-input-number @change="warningContentChange" :disabled="isCheck"
                v-model="item.monitorNumber"
                placeholder="对比值"
                style="width: 104px"
                v-if="!isCheck"
              />
              <span v-else>{{item.monitorNumber}}</span>
              <span>{{item.unit}}</span>
            </a-form-model-item>
            <template v-if="!isCheck">
              <i class="el-icon-circle-plus"
                style="font-size: 1.5em;padding: 5px;color: #22AC35;cursor: pointer;" 
                @click="handelAddLogicCondition"
              />
              <i class="el-icon-delete" style="font-size: 1.5em;padding: 5px;color: #f56c6c;cursor: pointer;"
                @click="delLogicCondition(index)"
              />
            </template>
          </a-row>
        </a-form-model-item>
        <a-form-model-item
          v-if="form.intelligentMonitorTargetList.length > 1"
          label=" "
          prop="isAnd"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 20 }"
          style="margin-top: -6px"
          :colon="false"
        >
          <span v-if="isCheck">{{ form.isAnd ? '同时满足所有条件' : '满足任意一个条件' }}</span>
          <a-radio-group v-model="form.isAnd" v-else>
            <a-radio :value="true">同时满足所有条件</a-radio>
            <a-radio :value="false">满足任意一个条件</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="预警通知" prop="warningInformUser"
          :rules="[
            { required: true, message: '请填写飞书邮箱，以逗号分隔', trigger: 'blur',},
            { validator: validatorEmails, trigger: 'blur',}
          ]"
        >
          <a-input  :disabled="isCheck" v-model.trim="form.warningInformUser" placeholder="请填写飞书邮箱，以逗号分隔" style="width: 440px"></a-input><span style="margin-left: 10px" v-if="!isCheck">{{userNum}}</span>
        </a-form-model-item>
        <a-form-model-item label="加急方式" prop="expeditedWay">
          <span v-if="isCheck">{{ expeditedWayMap[form.expeditedWay] || '关闭' }}</span>
          <a-select v-else v-model="form.expeditedWay" :disabled="isCheck" style="width: 216px">
            <a-select-option value="0">关闭</a-select-option>
            <a-select-option value="1">飞书应用内</a-select-option>
            <a-select-option value="2">飞书应用内+短信</a-select-option>
            <a-select-option value="3">飞书应用内+电话</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="提醒时间" prop="warnDateType"
              :rules="{ required: true, message: '请输入提醒内容', trigger: 'blur',}"
              :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }"
            >
              <div v-if="isCheck">{{form.warnDateType === '2'?'定时':'全天'}}</div>
              <a-radio-group name="warnDateType" v-model="form.warnDateType" v-else>
                <a-radio value="1">全天</a-radio>
                <a-radio value="2">定时</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="10" class="hour-range" v-if="form.warnDateType === '2'">
            <a-select :disabled="isCheck" v-model="form.warnDateStart" @change="dateStartChange" style="width: 60px;" :showArrow="false" :dropdownMatchSelectWidth="false">
              <a-select-option v-for="item in hourList" :key="item">{{item}}</a-select-option>
            </a-select>
            <span class="split-icon" :class="isCheck?'is-check':''">~</span>
            <a-select :disabled="isCheck" v-model="form.warnDateEnd" style="width: 60px" :showArrow="false" :dropdownMatchSelectWidth="false">
              <template v-for="item in hourList">
                <a-select-option :key="item" v-if="disableEndDate(item)">{{item}}</a-select-option>
              </template>
            </a-select>
            <a-popover placement="top">
              <template slot="content">当前时间范围以外，则不会给您发通知。</template>
              <icon-font type="icon-Question-Circle-Line"></icon-font>
            </a-popover>
          </a-col>
        </a-row>
      </a-form-model>
      <div slot="footer" v-if="isCheck"></div>
    </a-modal>
</template>
<script>
import { intelligentWarningDetails, addIntelligentWarning, editIntelligentWarning } from "@/api/mediadata"
import { getWarnDataSource, getDataAccount, getNormList } from "@/api/basicCyberData";
const targetItem = {
  monitorTargetId: undefined,
  monitorRule: undefined,
  monitorTargetName: '',
  monitorNumber: undefined,
  monitorType: 'METRIC'
}

export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      dataSet: [],
      accountList: [],
      form: {
        warnDateType: '2',
        executeWarnTaskInterval: undefined,
        monitorValueType: undefined,
        taskType: undefined,
        warningStatus: 1,
        taskName: '',
        expeditedWay: '0',
        mediaCode: undefined,
        monitorDataSource: undefined,
        monitorDataAccount: [],
        monitorDateScope: '4',
        monitorDataLevel: '账号',
        warningInformUser: '',
        warningContent: '',
        warnDateStart: '08:00',
        warnDateEnd: '22:00',
        isAnd: true,
        intelligentMonitorTargetList: [{
          ...targetItem
        }],
      },
      monitorRuleSet: {
        gte: '大于等于',
        gt: '大于',
        eq: '等于',
        lt: '小于',
        lte: '小于等于',
      },
      dateScopeMap: {
        '1': '最近3天',
        '2': '最近7天',
        '3': '最近3小时',
        '4': '当日(0点开始)',
      },
      monitorValueTypeMap: {
        '1': '值',
        '2': '变动范围'
      },
      taskIntervalList: ['10分钟内', '30分钟内', '1小时内', '2小时内', '3小时内'],
      nowObj: null,
      normList: [],
      isCheck: false,
      timeout: null,
      editNorm: [],
      hourList: [],
      expeditedWayMap: {
        '0': '关闭',
        '1': '飞书应用内',
        '2': '飞书应用内+短信',
        '3': '飞书应用内+电话',
      }
    };
  },
  props: ['code'],
  computed: {
    monitorDataAccountDetails() {
      let monitorDataAccount = this.form.monitorDataAccount || []
      console.log(this.form.monitorDataAccount )
      return monitorDataAccount.map(v => {
        let obj = this.accountList.find(val => val.accountId === v)
        return obj?obj.accountName:''
      }).toString()
    },
    userNum() {
      let warningInformUser = this.form.warningInformUser
      let arr = warningInformUser.split(',').filter(v => v)
      return `${arr.length}个`
    },
    shortNorm() {
      return this.editNorm.filter(v => !this.normList.find(val => val.field === v.field))
    }
  },
  methods: {
    disableEndDate(endDate) {
      return Number(this.form.warnDateStart.slice(0,2)) <= Number(endDate.slice(0, 2))
    },
    dateStartChange() {
      if(Number(this.form.warnDateStart.slice(0,2)) > Number(this.form.warnDateEnd.slice(0, 2))) {
        this.form.warnDateEnd = this.form.warnDateStart
      }
    },
    async taskTypeChange() {
      this.editNorm = []
      if (this.form.taskType === '1') {
        this.form.executeWarnTaskInterval = '1小时内'
        this.form.monitorValueType = '2'
        this.form.intelligentMonitorTargetList = [{
          monitorTargetId: undefined,
          monitorRule: 'eq',
          monitorTargetName: '',
          monitorNumber: 0,
          monitorType: 'METRIC'
        }]
        if(!this.form.mediaCode) {
          this.form.mediaCode = 'FB'
        }
        await this.getNormList('花费')
        if(this.normList.length) {
          this.form.intelligentMonitorTargetList[0].monitorTargetId = this.normList[0].field
          this.form.intelligentMonitorTargetList[0].monitorTargetName = this.normList[0].name
          this.form.intelligentMonitorTargetList[0].unit = this.normList[0].fieldUnit&&this.normList[0].fieldUnit.symbol || ''
        }
        this.warningContentChange()
      } else {
        this.form.intelligentMonitorTargetList = [{
          ...targetItem
        }]
        this.form.mediaCode = undefined
        this.form.monitorDataAccount = undefined
        this.form.executeWarnTaskInterval = undefined
        this.form.monitorValueType = undefined
        this.accountList = []
        this.normList = []
        this.warningContentChange()
      }
    },
    searchNorm(val) {
      this.getNormList(val);
    },
    warningContentChange() {
      let item = this.form.intelligentMonitorTargetList[0]
      let obj = this.normList.find(v => v.field === item.monitorTargetId)
      let monitorTargetName = obj?obj.name:''
      let monitorDataSource = this.dataSet.find(v => v.mediaCode === this.form.mediaCode)?.name || ''
      let executeWarnTaskInterval = this.form.executeWarnTaskInterval || ''
      let monitorDataLevel = this.form.monitorDataLevel || ''
      let monitorValueType = this.monitorValueTypeMap[this.form.monitorValueType] || ''
      this.form.warningContent = `${monitorDataSource}${monitorDataLevel}${executeWarnTaskInterval}${monitorTargetName}${monitorValueType}${this.monitorRuleSet[item.monitorRule] || ''}${!item.monitorNumber&& item.monitorNumber !== 0?'':item.monitorNumber}${item.unit || ''},请关注！`
    },
    changeDataSource() {
      // this.form.monitorDataLevel = this.form.mediaCode.indexOf('AF')!== -1?'产品':'账号'
      this.accountList = []
      this.editNorm = []
      this.getAcccountList();
      this.form.monitorDataAccount = undefined
      this.form.executeWarnTaskInterval = undefined
      this.form.monitorValueType = undefined
      this.getNormList();
      this.form.intelligentMonitorTargetList = [{
        ...targetItem
      }]
      this.warningContentChange()
    },
    handleSearchAccount(val, orderAccountIds = {}) {
      this.fetchAcccount(val, orderAccountIds);
    },
    fetchAcccount(val, orderAccountIds) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.timeout = setTimeout(() => {
        this.getAcccountList(val, orderAccountIds);
      }, 500);
    },
    normChange(value, index) {
      let obj = this.normList.find(v => v.field === value)
      this.form.intelligentMonitorTargetList[index].monitorTargetName = obj.name
      this.form.intelligentMonitorTargetList[index].unit = obj.fieldUnit&&obj.fieldUnit.symbol || ''
      this.warningContentChange()
      this.editNorm = []
    },
    async getNormList(keyWord) {
      const params = {
        mediaCode: this.form.mediaCode,
      };
      const odata = {
        timelyGetDataFlag: true,
        filterEnable: true,
        searchKeyWord: keyWord,
      };
      this.normList = []
      const { code, data } = await getNormList(params, odata);  
      if (code != "200") return;
      this.normList = data.recordList;
    },
    async getAcccountList(keyWord, orderAccountIds) {
      this.accountList = []
      if(!this.form.mediaCode) return;
      const params = {
        mediaCode: this.form.mediaCode,
      };
      const dataParams = {
        filterEnable: true,
        orderAccountIds,
        searchKeyWord: keyWord,
      };
      const { code, data } = await getDataAccount(params, dataParams);
      if (code != 200) return;
      this.accountList = data.recordList;
      return data.recordList
    },
    handelAddLogicCondition() {
      let condition =  {
        ...targetItem
      }
      this.form.intelligentMonitorTargetList.push(condition);
    },
    delLogicCondition(index) {
      if (this.form.intelligentMonitorTargetList.length > 1) {
        this.form.intelligentMonitorTargetList.splice(index, 1);
      }
      if (this.form.intelligentMonitorTargetList.length <= 1) {
        this.form.isAnd = true
      }
    },
    validatorName(rule, value, callback) {
      if(!/^[\a-\z\A-\Z0-9\u4e00-\u9fe5\-\_]+$/.test(value)) {
        callback(new Error('只能输入中英文数字-_'))
      } else {
        callback()
      }
    },
    validatorEmails(rule, value, callback) {
      if(!/^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},*[\W]*)+$/.test(value)) {
        callback(new Error('请正确填写飞书邮箱，以逗号分隔'))
      } else {
        callback()
      }
    },
    init(data, isCheck) {
      this.visible = true
      this.isCheck = isCheck || false
      this.$nextTick(() => {
        this.editNorm = []
        if(data) {
          this.nowObj = data
          intelligentWarningDetails(data.id).then((res) => {
            let data = res.data
            let account = data.monitorDataAccount.split(',')
            let monitorDateScope = ''
            if(data.monitorDateScope === '0') {
              monitorDateScope = '4'
            } else if(data.monitorTimeType === '2'&& data.monitorDateScope === '3') {
              monitorDateScope = '3'
            } else if(data.monitorTimeType === '1'&& data.monitorDateScope === '3') {
              monitorDateScope = '1'
            } else if(data.monitorTimeType === '1'&& data.monitorDateScope === '7') {
              monitorDateScope = '2'
            }
            this.form = {
              warnDateType: data.warnDateType,
              executeWarnTaskInterval: `${data.executeWarnTaskInterval}${data.executeWarnTaskIntervalUnit === '1'?'分钟':'小时'}内`,
              monitorValueType: data.monitorValueType,
              taskType: data.taskType,
              warningStatus: data.warningStatus,
              taskName: data.taskName,
              mediaCode: data.mediaCode,
              monitorDataSource: data.monitorDataSource,
              monitorDataAccount: account,
              monitorDateScope: monitorDateScope,
              monitorDataLevel: data.monitorDataLevel,
              warningInformUser: data.warningInformUser,
              warningContent: data.warningContent,
              intelligentMonitorTargetList: data.intelligentMonitorTargetList,
              warnDateStart: data.warnDateStart,
              warnDateEnd: data.warnDateEnd,
              isAnd: typeof data.isAnd === 'boolean' ? data.isAnd : true,
              expeditedWay: data.expeditedWay ? String(data.expeditedWay) : (data.isExpedited == '1' ? '1' : '0'),
            }
            if (account && account.length > 0) {
              this.handleSearchAccount("", [...account]);
            }
            this.editNorm = data.intelligentMonitorTargetList.map(v => ({
              field: v.monitorTargetId,
              name: v.monitorTargetName
            }))
            this.getAcccountList();
            this.getNormList();
          })
          // .finally(() => this.loading = false)
        } else {
          this.nowObj = null
          this.form.mediaCode = "FB"
          this.getAcccountList();
          this.form.taskType = "1"
          this.taskTypeChange()
        }
      })
    },
    handleOk(e) {
      this.$refs.form.validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.form))
          let obj = this.dataSet.find(v => v.mediaCode === params.mediaCode) || {}
          params.warningInformWay = 1
          params.monitorDataSourceName = obj.name
          params.monitorDataSourceId = obj.id
          params.monitorDataSource = obj.resource
          params.monitorDataAccount = params.monitorDataAccount.toString()
          if(params.monitorDateScope === '4') {
            params.monitorDateScope = '0'
            params.monitorTimeType = '2'
          } else if(params.monitorDateScope === '3') {
            params.monitorDateScope = '3'
            params.monitorTimeType = '2'
          } else if(params.monitorDateScope === '1') {
            params.monitorDateScope = '3'
            params.monitorTimeType = '1'
          } else if(params.monitorDateScope === '2') {
            params.monitorDateScope = '7'
            params.monitorTimeType = '1'
          }
          console.log(params)
          params.expeditedWay = params.expeditedWay || '0'
          params.isExpedited = params.expeditedWay !== '0' ? '1' : '0'
          // 拆分预警频次
          if(params.executeWarnTaskInterval.indexOf('小时') > -1) {
            params.executeWarnTaskIntervalUnit = '2'
            params.executeWarnTaskInterval = Number(params.executeWarnTaskInterval.slice(0, 1))
          } else {
            params.executeWarnTaskIntervalUnit = '1'
            params.executeWarnTaskInterval = Number(params.executeWarnTaskInterval.slice(0, 2))
          }
          console.log(params)
          this.confirmLoading = true;
          let api = this.nowObj?editIntelligentWarning:addIntelligentWarning
          api(params, this.nowObj?.id).then((res) => {
            this.$message.success(`${this.nowObj?'编辑':'新增'}成功！`)
            this.visible = false
            this.reset()
            this.$emit('success')
          }).finally(() => this.confirmLoading = false)
        } else {
          return false;
        }
      });
    },
    handleCancel(e) {
      this.reset()
      this.visible = false;
    },
    reset() {
      this.form = {
        warnDateType: '2',
        executeWarnTaskInterval: undefined,
        monitorValueType: undefined,
        taskType: undefined,
        warningStatus: 1,
        taskName: '',
        mediaCode: undefined,
        monitorDataSource: undefined,
        monitorDataAccount: [],
        monitorDateScope: "4",
        monitorDataLevel: '账号',
        warningInformUser: '',
        warningContent: '',
        expeditedWay: '0',
        warnDateStart: '08:00',
        warnDateEnd: '22:00',
        isAnd: true,
        intelligentMonitorTargetList: [{
          ...targetItem
        }]
      }
      this.accountList = []
      this.normList = []
      this.$refs.form.clearValidate()
    },
    async getAcccountList(keyWord, orderAccountIds) {
      const params = {
        mediaCode: this.form.mediaCode,
      };
      const dataParams = {
        filterEnable: true,
        orderAccountIds,
        searchKeyWord: keyWord,
      };
      console.log(dataParams)
      const { code, data } = await getDataAccount(params, dataParams);
      this.accountList = data.recordList;
      if (code != 200) return;
    },
    async loadDataSet() {
      const { code, data } = await getWarnDataSource();
      this.dataSet = data;
      if (code != "200") return;
    },
  },
  mounted() {
    this.loadDataSet();
    let arr = []
    for (let i = 0; i < 25; i++) {
      let str = i<10?`0${i}:00`:`${i}:00`
      arr.push(str)
    }
    this.hourList = arr
  }
};
</script>
<style lang="less" scoped>
.add-warning-modal {
  /deep/ .ant-select, /deep/ .ant-input,  /deep/ .ant-input-number {
    width: 216px;
  }
  .top-info {
    padding-left: 90px;
    margin-top: -20px;
    margin-bottom: 20px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #2D3446;
    background: #cfddff;
    padding: 10px;
    border-radius: 5px;
    .anticon {
      color: #4278ff;
      font-size: 16px;
      margin-right: 10px;
    }
  }
  .data-range {
    margin-bottom: 0;
    .ant-form-item {
      margin-right: 8px;
    }
  }
  .include-division-row {
    .ant-form-item {
      margin-right: 4px;
    }
  }
  &.is-check {
    /deep/ .ant-form-item-required::before {
      display: none!important;
    }
    /deep/ .ant-select, /deep/ .ant-input,  /deep/ .ant-input-number {
      border: none;
      background-color: transparent;
      margin-left: 0;
      padding-left: 0;
      color: #677392;
      .ant-select-selection {
        border: 0;
        background-color: transparent;
        color: #677392;
        margin-left: 0;
      }
      .ant-select-selection__rendered {
        margin-left: 0;
      }
      .ant-select-arrow-icon {
        display: none;
      }
    }
    /deep/.ant-checkbox-disabled + span {
      color: #677392;
      font-weight: normal;
    }
    /deep/ .ant-select {
      width: auto!important;
    }
    /deep/ .ant-input {
    width: 100%!important;
    }
    /deep/ .ant-input-number-input {
      padding-left: 0;
    }
  }
  .hour-range {
    padding-top: 4px;
    .anticon {
      margin-left: 10px;
    }
    .split-icon {
      margin-left: -5px;
      margin-right: -5px;
      &.is-check {
        margin-left: 5px;
        margin-right: 5px;
      }
    }
    /deep/ .ant-select {
      .ant-select-selection {
        background: transparent;
        box-shadow: none;
      }
      &:first-of-type {
        .ant-select-selection {
          border-right: 0px;
          border-top-right-radius: 0%;
          border-bottom-right-radius: 0%;
          .ant-select-selection__rendered {
            margin-right: 0px;
          }
        }
      }
      &:last-of-type {
        .ant-select-selection {
          border-left: 0px;
          border-top-left-radius: 0%;
          border-bottom-left-radius: 0%;
          .ant-select-selection__rendered {
            margin-right: 0px;
          }
        }
      }
    }
  }
}
</style>